export const clinicsTexts = {
  center: 'مرکز',
  clinics: 'مراکز درمانی',
  searchPlaceholder: 'جستجو در مراکز درمانی',
  specialities: 'تخصص های مراکز درمانی',
  specialityPrefix: 'مرکز',
  cities: 'شهرهای دارای مراکز درمانی',
  suggestedSevices: 'پیشنهاد خدمات',
  installment: 'اقساطی',
  doctorServiceMock: 'خدمات دکتر بهمن رستمی',
  psychologyService: 'مشاوره روانشناسی',
  viewMore: 'مشاهده همه',
  aboutClinicServiceTitle: 'مراکز درمانی ایران با نوبت‌دهی اینترنتی',
  aboutClinicServiceText: [
    'نوبت‌دهی آنلاین مراکز درمانی ایران در تپسی دکتر این امکان را فراهم کرده است که به‌صورت اینترنتی از مراکز درمانی مختلف در سراسر کشور شامل بیمارستان‌ها، کلینیک‌ها، آزمایشگاه‌ها، مراکز تصویربرداری و درمانگاه‌ها نوبت دریافت کنید. می‌توانید مراکز درمانی موردنظر خود را جست‌وجو کرده و در کوتاه‌ترین زمان ممکن نوبت خود را رزرو نمایید.',
    'برای دریافت نوبت اینترنتی از مراکز درمانی ایران، کافیست مرکز درمانی و خدمت موردنظر خود را انتخاب کنید. برای دریافت نوبت اینترنتی از مراکز درمانی ایران، کافی است مرکز درمانی و خدمت موردنظر خود را انتخاب کنید. سپس می‌توانید اولین زمان خالی را مشاهده کرده و به‌صورت آنلاین نوبت خود را ثبت کنید.',
    'تپسی دکتر با هدف تسهیل دسترسی به خدمات درمانی، امکان جست‌وجو، مقایسه و رزرو نوبت از مراکز مختلف را فراهم کرده است تا بدون نیاز به صرف زمان زیاد، مرکز درمانی مناسب خود را پیدا کرده و به‌راحتی نوبت بگیرید.',
  ],
};

export const clinickSpecialitiesTexts = {
  specialities: 'لیست‌تخصص‌ها',
  searchPlaceholder: 'جستجوی تخصص',
};

export const clinicsCitiesTexts = {
  searchPlaceholder: 'جستجوی شهر',
};
